import React, {Fragment, useMemo, useState} from "react";
import EnhancedModal from "../../../../components/enhanced-modal";
import {Button, Col, Row, Select} from "antd";
import {GUTTER_MD, MODAL_WIDTH_LG, TABLE_COL_MIN_WIDTH_ID} from "../../../../styles/constants";
import InfiniteScrollTable from "../../../../components/infinite-scroll-table";
import {compose} from "redux";
import {translate} from "react-i18next";
import {connect} from "react-redux";
import {datasetBuilderDataCubeDataFlowList} from "../actions";
import {
    CUBE_CHOICE,
    DATAFLOW_CUBE_CHOICE,
    SELECT_DATAFLOW_CUBE_CHOICES
} from "./components/utils";
import Call from "../../../../hocs/call";
import {appendQueryTableViewDatasetBuilder} from "./actions";

const mapStateToProps = (state) => ({
    connId: state.scenes.mappingHandler.datasetBuilder.index.connId,
    connections: state.scenes.mappingHandler.datasetBuilder.index.connections,
    cubes: state.scenes.mappingHandler.datasetBuilder.index.cubes,
    dataflows: state.scenes.mappingHandler.datasetBuilder.index.dataflows,
});

const mapDispatchToProps = dispatch => ({
    appendQuery: ({connId, name, dbType}) => dispatch(appendQueryTableViewDatasetBuilder(connId, name, dbType)),
    fetchCubesAndFlows: (connId) => dispatch(datasetBuilderDataCubeDataFlowList(connId)),
});

const DataflowCubeSelector = ({
                                  connId,
                                  connections,
                                  t,
                                  fetchCubesAndFlows,
                                  appendQuery,
                                  cubes,
                                  dataflows
                              }) => {
    const [showModal, setShowModal] = useState(false);
    const [selectedType, setSelectedType] = useState(DATAFLOW_CUBE_CHOICE);
    const objectsList = useMemo(() => selectedType === DATAFLOW_CUBE_CHOICE ? [...(cubes || []), ...(dataflows || [])] : selectedType === CUBE_CHOICE ? cubes : dataflows, [cubes, dataflows, selectedType]);
    const selectedConnection = useMemo(() => (connections || []).find(item => item.entityId === connId), [connections, connId]);

    return <Fragment>
        <Button
            onClick={() => setShowModal(true)}
            style={{width: "100%"}}
        >
            {t('scenes.mappingHandler.DatasetBuilder.dataflowCubeSelector.title')}
        </Button>
        <EnhancedModal
            visible={showModal}
            title={t('scenes.mappingHandler.DatasetBuilder.dataflowCubeSelector.title')}
            footer={<Button
                onClick={() => setShowModal(false)}>{t('commons.buttons.close.title')}</Button>}
            onCancel={() => setShowModal(false)}
            width={MODAL_WIDTH_LG}
        >
            <Call cb={fetchCubesAndFlows} cbParam={connId} disabled={!!cubes}>
                <InfiniteScrollTable
                    data={objectsList || []}
                    multilangStrDataIndexes={["Id"]}
                    getRowKey={({Code}) => Code}
                    columns={[{
                        title: t('data.datasetBuilder.type.shortLabel'),
                        dataIndex: 'Type',
                        minWidth: TABLE_COL_MIN_WIDTH_ID
                    }, {
                        title: t('data.datasetBuilder.name.shortLabel'),
                        dataIndex: 'Id',
                        minWidth: TABLE_COL_MIN_WIDTH_ID
                    }, {
                        title: t('data.datasetBuilder.viewName.shortLabel'),
                        dataIndex: 'name',
                        minWidth: TABLE_COL_MIN_WIDTH_ID
                    }
                    ]}
                    onRowClick={({name}) => {
                        if (appendQuery) {
                            appendQuery({connId, name, dbType: selectedConnection ? selectedConnection.realDbType || selectedConnection.dbType : null})
                        }
                        setShowModal(false);
                    }}
                    rightActions={<Row type="flex" gutter={GUTTER_MD}>
                        <Col>
                            <Select
                                showSearch
                                filterOption={(inputValue, {props}) =>
                                    props.title.toLowerCase().includes(inputValue.toLowerCase())
                                }
                                title={
                                    t('scenes.mappingHandler.DatasetBuilder.dataflowCubeSelector.title')
                                }
                                value={selectedType}
                                onChange={(newValue) => setSelectedType(newValue)}
                            >
                                {SELECT_DATAFLOW_CUBE_CHOICES.map((choice) => {
                                    return (
                                        <Select.Option
                                            key={choice.value}
                                            value={choice.value}
                                            title={choice.label}
                                        >
                                            {choice.label}
                                        </Select.Option>
                                    );
                                })
                                }
                            </Select>
                        </Col>
                    </Row>}
                />
            </Call>
        </EnhancedModal>
    </Fragment>
};

export default compose(
    translate(),
    connect(mapStateToProps, mapDispatchToProps)
)(DataflowCubeSelector);